<template>
  <div>
    <!-- <h1 class="app-title">Skyhost</h1> -->
    <div v-show="isStreaming">
      <OvenPlayer
        :webrtcUrl="webrtcUrl"
        @streaming-updated="handleStreamingUpdate"
      />
    </div>
    <div v-show="!isStreaming" class="centered-box">
      <Map :eventDetails="eventDetails" />
    </div>
    <!-- <GalleryView v-if="!hmsStore.hmsIsSomeoneScreenSharing" /> -->
  </div>
</template>

<script setup>
import { ref, defineProps, watch, onMounted, onBeforeUnmount } from "vue";
import Map from "./Map.vue";
import OvenPlayer from "./OvenPlayer.vue";
import { subscribeToUserStreamingUrls } from "@/services/streamingService";

const isStreaming = ref(false);
const webrtcUrl = ref(null);
let unsubscribeStreaming = null;

const props = defineProps({
  eventDetails: {
    type: Object,
    default: () => ({}),
  },
});

function setupStreamingListener(userId) {
  if (!userId) {
    console.warn("No userId provided to streaming listener");
    return;
  }

  // Clean up existing listener
  if (unsubscribeStreaming) {
    unsubscribeStreaming();
    unsubscribeStreaming = null;
  }

  // Subscribe to real-time updates
  unsubscribeStreaming = subscribeToUserStreamingUrls(
    userId,
    (streamingUrls) => {
      if (streamingUrls && streamingUrls.webrtcUrl) {
        webrtcUrl.value = streamingUrls.webrtcUrl;
        console.log("Streaming URL updated:", webrtcUrl.value);
      } else {
        webrtcUrl.value = null;
        console.warn("No streaming URL found for pilot");
      }
    }
  );
}

watch(
  () => props.eventDetails?.creatorUserId,
  (newUserId) => {
    console.log("CreatorUserId changed in UConference:", newUserId);
    if (newUserId) {
      setupStreamingListener(newUserId);
    } else if (unsubscribeStreaming) {
      unsubscribeStreaming();
      unsubscribeStreaming = null;
      webrtcUrl.value = null;
    }
  },
  { immediate: true }
);

onMounted(() => {
  if (props.eventDetails?.creatorUserId) {
    setupStreamingListener(props.eventDetails.creatorUserId);
  }
});

onBeforeUnmount(() => {
  if (unsubscribeStreaming) {
    unsubscribeStreaming();
    unsubscribeStreaming = null;
  }
});

function handleStreamingUpdate(newStreamingStatus) {
  isStreaming.value = newStreamingStatus;
}
</script>

<style lang="scss" scoped>
.screenshare {
  &-view {
    display: flex;
    flex-direction: row;
    height: 100%;
    justify-content: space-around;
    @media (max-width: 600px) {
      flex-direction: column;
    }

    & > .screenshare {
      display: flex;
      height: 100%;
      align-items: center;
      justify-content: center;
      flex: 1 auto;
      @media (max-width: 600px) {
        flex-basis: auto;
        height: unset;
      }
    }

    & > .gallery {
      flex: 1 20%;
      @media (max-width: 600px) {
        flex-basis: auto;
        height: 20%;
        flex-grow: 1;
      }
    }
  }
}
.centered-box {
  flex: 1;
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  // background-color: red;
  z-index: 0; /* Set z-index to appear on top of other elements */
}
</style>
